import template from './mercuryAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              const self = this;
              self.apiKey = '';
              self.token = '';
              self.confirm = () => {
                $mdDialog.hide({ apiKey: self.apiKey, token: self.token });
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
